export const version = "hash/5.8.0";
//# sourceMappingURL=_version.js.map